<div class="main-wrap">
  <div class="left-box">
    <p-toast></p-toast>
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
    <p>
      Booking ID: {{booking.id}}
    </p>

    <div [formGroup]="bookingForm" class="booking-form">
      <div class="input-box">
        <p>
          School
        </p>
        <p>
          <input pInputText [value]="booking.school.name" readonly>
        </p>
      </div>
      <div class="input-box">
        <p>
          First name
        </p>
        <input pInputText formControlName="firstName">
      </div>
      <div class="input-box">
        <p>
          Last name
        </p>
        <input pInputText formControlName="lastName">
      </div>
      <div class="input-box">
        <p>
          Start date
        </p>
        <p-calendar [monthNavigator]="true" [yearRange]="yearRange" [yearNavigator]="true"
        formControlName="startDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
      </div>
      <div class="input-box">
        <p>
          End date
        </p>
        <p-calendar [monthNavigator]="true" [yearRange]="yearRange" [yearNavigator]="true"
        formControlName="endDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
      </div>
      <div class="input-box" >
        <p *ngIf="duration > 1">
          Duration: {{duration}} weeks
        </p>
        <p *ngIf="duration == 1">
          Duration: {{duration}} week
        </p>
      </div>
      <div class="input-box">
        <p>
          Language of vademecum
        </p>
        <div *ngIf="bookingForm">
          <p-dropdown [options]="studentLanguages" optionLabel="name" formControlName="studentLanguage"></p-dropdown>
        </div>
      </div>
    </div>
    <div class="personal-form" [formGroup]="personalForm" *ngIf="bookingService.hasVademecum && personalForm">

      <div class="input-box">
        <p>
          Student GSM
        </p>
        <input pInputText formControlName="studentMobile">
      </div>

      <div class="input-box">
        <p>
          First parent GSM
        </p>
        <input pInputText formControlName="firstParentMobile">
      </div>

      <div class="input-box">
        <p>
          Second parent GSM
        </p>
        <input pInputText formControlName="secondParentMobile">
      </div>

      <div class="input-box">
        <p>
          First parent first name
        </p>
        <input pInputText formControlName="firstParentFirstName">
      </div>

      <div class="input-box">
        <p>
          First parent last name
        </p>
        <input pInputText formControlName="firstParentLastName">
      </div>

      <div class="input-box">
        <p>
          Second parent first name
        </p>
        <input pInputText formControlName="secondParentFirstName">
      </div>

      <div class="input-box">
        <p>
          Second parent last name
        </p>
        <input pInputText formControlName="secondParentLastName">
      </div>
    </div>
    <div class="button-container">
      <div class="p-button-wrap">
        <p-button icon="pi pi-check" label="Submit" (onClick)="update()"></p-button>
      </div>
      <div class="p-button-wrap">
        <p-button icon="pi pi-trash" label="Delete" (onClick)="delete()" styleClass="p-button-danger"></p-button>
      </div>
    </div>
  </div>
  <div class="right-box">
    <p>
      Created by: {{booking.createdBy!.name}}
    </p>
    <br>
    <p>
      Created time: {{booking.created!.toDate() | date: "dd/MM/yyyy 'at' HH:mm:ss"}}
    </p>
    <p>
      Link for dashboard: {{dashboardUrl}}
    </p>

    <p-button label="Formulaire" routerLink="/student-informations/{{booking.uuid}}"></p-button>
  </div>
</div>